import { render, staticRenderFns } from "./OrderCar.vue?vue&type=template&id=50d6c1c2&scoped=true"
import script from "./OrderCar.vue?vue&type=script&lang=js"
export * from "./OrderCar.vue?vue&type=script&lang=js"
import style0 from "./OrderCar.vue?vue&type=style&index=0&id=50d6c1c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d6c1c2",
  null
  
)

export default component.exports